exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-item[data-v-4525be5e]{background:transparent}", ""]);

// exports
